export default __webpack_public_path__ + "static/media/BLD.96a8c21a.png";